@if (logs !== undefined) {
  <div class="grid">
    <field-tools class="col-12 md:col-3 lg:col-3" [dataTitle]="'Menu_ErrorLog' | translate">
      <div class="scroll-table">
        <p-listbox
          [options]="logs"
          optionLabel="file_name"
          (onClick)="open_log_file($event)"
          [filter]="true"
          [listStyle]="{ width: '100%'}"
          scrollHeight="75vh"
          >
          <ng-template let-logitem pTemplate="item">
            <div class="flex align-items-center">
              <div class="margin-left">
                <span class="title">
                  {{ logitem.file_name }}
                </span>
              </div>
            </div>
          </ng-template>
        </p-listbox>
      </div>
    </field-tools>
    @if (file !=='') {
      <field-tools class="col-12 md:col-9 lg:col-9" [dataTitle]="'Display' | translate">
        <dm-fieldset-header [backGround]="false"> </dm-fieldset-header>
        <p-table [value]="data"  selectionMode="single" class="width-100">
          <ng-template pTemplate="caption">
            <span class="header-grid-wrapper">
              <span class="align-right">{{'detail' | translate}}</span>
            </span>
            <button type="button" pButton pRipple icon="pi pi-file-excel"  class="cust-width p-button-primary right btn-excel"
              pTooltip="{{'Export_Xlsx' | translate}}" tooltipPosition="left"
              (click)="exportExcel()"
            ></button>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="datetime" style="width:20%">{{'Date' | translate}}
                <p-sortIcon field="datetime"></p-sortIcon>
              </th>
              <th style="min-width:15rem">
                <div class="flex align-items-center">
                  {{'Message' | translate}}
                  <p-columnFilter type="text" field="message" display="menu"></p-columnFilter>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-info>
            <tr>
              <td>{{ info.datetime | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ info.message}}</td>
            </tr>
          </ng-template>
        </p-table>
      </field-tools>
    }
  </div>
}
